import { graphql, useStaticQuery } from 'gatsby'
import React, { memo, useCallback, useContext, useMemo } from 'react'
import { useFormContext } from 'react-hook-form'
import { StageContext } from './context/formContext'

export default function PricingCards() {

    const { data } = useStaticQuery(graphql`
        query Pricing {
            data:datoCmsPricingCard {
                pricing {
                    mostPopular
                    name
                    range
                    tC
                    cost
                    costNote
                    pricingPoint {
                        name
                        tC
                    }                    
                }
            }
        }
    `)

    const { setValue } = useFormContext()
    const { setStage } = useContext(StageContext)

    const changeStage = useCallback((e, name) => {
        e.preventDefault()
        setStage(1)
        setValue('pricing', name)
        document.querySelector('.overlay--form').classList.add('active');
    }, [setStage, setValue])

    return (
        <>
            {data.pricing.map((pricing, index) => {
                return (
                    <div key={index} className={'w-50 m-w100 m-pl0 m-pr0 ' + (index === 0 ? 'pr10 m-pb20 ' : 'pl10')} >
                        <div className={' br20  p60  flex flex-col h-100p m-p20 '+(pricing.mostPopular ? 'bg-green most-popular' : 'bg-white')}>  

                            <div className='pb40 flex justify-between bb1 m-pb20 '>
                                <div className='flex flex-col mr10'>
                                    <p style={{ opacity: pricing.mostPopular ? 1 : 0 }} className='mb10 medium'> Most Popular</p>
                                    <div className='flex '>

                                        <div className='main--logo h-50px' />
                                        <h3 className='h3 m0 light mr10 '>{pricing.name}</h3>
                                    </div>
                                </div>
                                <div className='hide'>
                                    <p style={{ opacity: pricing.costNote ? 1 : 0 }} className='mb10 text-grey medium'>{pricing.costNote}</p>
                                    <h3 className='h3 m0 semi-bold'>${pricing.cost}*</h3>
                                    <p className='m0 text-grey small-12 mt2 h-15 '><span className={(pricing.mostPopular ? 'hide' : ' ')}>+ 4.5% on sale of vehicle</span></p>
                                </div>
                            </div>
                            <div className='pt30 pb40 bb1 m-pt20 m-pb20  '>
                                <FormatRange range={pricing.range} />
                            </div>
                            <div className='pt40 pb40 bb1 flex-grow-1 m-pt20 m-pb20 '>
                                {pricing.pricingPoint.map((point, index) => {

                                    return (
                                        <div key={index} className='flex mb10 align-center'>

                                            <div className='dot-point mr10 flex justify-center align-center'>
                                                <div className='tick' />
                                            </div>

                                            <p className='m0 small-15 '>
                                                <span className='semi-bold'> {point.name} </span>
                                                {point.tC ? `(${point.tC})` : null}
                                            </p>
                                        </div>
                                    )
                                })}
                            </div>
                            <div className='pt40 flex justify-between align-center m-flex-col m-align-start m-pt20 '>
                                <p className='m0 small-12 m-pb20 '>*{pricing.tC}</p>
                                <button onClick={(e) => changeStage(e, pricing.name)} className={'select-button button ' + (index === 1 ? 'not-popular' : '')}>
                                    <span>Select</span>
                                </button>

                            </div>
                        </div>
                    </div>
                )
            })}
        </>
    )
}

const FormatRange = memo(({ range }) => {
    const ranges = useMemo(() => range.split('**'), [range])
    return (
        <p style={{height:'60px'}} className='max-365 m0 large'><span className='op-50'>{ranges[0]}</span> {ranges[1]}</p>
    )
})
